<template>
  <div>
  	 <md-empty-state
      md-icon="devices_other"
      md-label="SDK管理后台"
      md-description="苏州小森林网络科技有限公司">
		  	<md-content>
		    <form novalidate class="md-layout" @submit.prevent="validateUser"  ref="ruleForm2">
		      <md-card class="md-layout-item md-size-100 md-small-size-100">
		        <md-card-header>
		          <div class="md-title">用户登录</div>
		        </md-card-header>
		
		        <md-card-content>
		        	
		          <div class="md-layout md-gutter">
		            <div class="md-layout-item md-small-size-100">
		           			 <md-field md-clearable :class="getValidationClass('account')">
								      <label>用户名</label>
								      <md-input  v-model.trim="$v.account.$model" required :disabled="logining"></md-input>
								      <span class="md-error" v-if="!$v.account.required">用户名不能为空</span>
		                  <span class="md-error" v-else-if="!$v.account.minlength">用户名太短了</span>
		              </md-field>
								
								    <md-field :class="getValidationClass('checkPass')">
								      <label>密码</label>
								      <md-input v-model.trim="$v.checkPass.$model" type="password" required :disabled="logining"></md-input>
								      <span class="md-error" v-if="!$v.checkPass.required">密码不能为空</span>
		                  <span class="md-error" v-else-if="!$v.checkPass.minlength">密码太短了</span>
								    </md-field>
		           	
		            </div>
		
		          </div>
		
		
		        </md-card-content>
		
		        <md-progress-bar md-mode="indeterminate" v-if="logining"  />
		
		        <md-card-actions>
		          <md-button type="submit" class="md-primary" >登录</md-button>
		        </md-card-actions>
		      </md-card>
		
		      <md-snackbar :md-active.sync="userSaved">登录成功!</md-snackbar>
		    </form>
		    </md-content>
     </md-empty-state>
     <md-dialog-alert
      :md-active.sync="errorDialog"
      :md-content="Msg"
      md-confirm-text="知道了" />
  </div>

</template>

<script>
import { slogin } from "../api/api";
import { setCookie, getCookie, delCookie } from "../common/js/cookie.js";

import { required, minLength, between } from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      logining: false,
      account: "",
      checkPass: "",
      checked: true,
      userSaved:false,
      errorDialog:false,
      Msg:'',
    };
  },
 validations: {
    account: {
      required,
      minLength: minLength(2)
    },
    checkPass: {
      between: minLength(6)
    }
  },
  created() {
    let that = this;
    document.onkeypress = function(e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13 ) {
        that.handleSubmit2();
        return false;
      }
    };
  },
  methods: {
  	getValidationClass (fieldName) {
    const field = this.$v[fieldName]

    if (field) {
      return {
        'md-invalid': field.$invalid && field.$dirty
      }
    }
  },
  	validateUser () {
  	
        this.$v.$touch()

        if (!this.$v.$invalid) {
	          this.logining = true;

			          var loginParams = {
			            username: this.account,
			            password: this.checkPass
			          };
			         
	          		slogin(loginParams).then(res => {
		            this.logining = false;
      
		            let { msg, code, data } = res;
		            if (code !== 200) {
		             this.errorDialog=true;
		             this.Msg=msg;
		             
		            } else {
		              setCookie("login", data.token, 60 * 60 * 24);
		              setCookie("user", this.account, 60 * 60 * 24);
		              this.userSaved=true;
		              this.$router.push({ path: "/" });
		            }
		          });
			         
			          
        }
   },
  },
   mounted() {
			var login = getCookie('login');
			if(login){
				this.$router.push("/")
			}
		 }
};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// Login.vue?621e9e92